<template>
  <md-toolbar
    id="toolbar"
    md-elevation="0"
    class="md-absolute bgimg"
    :class="extraNavClasses"
    :color-on-scroll="colorOnScroll"
    style=""
  >
    <div class="md-toolbar-row md-collapse-lateral">
      <div class="md-toolbar-section-start">
        <!-- 多租户 -->
        <!-- 这里考虑一下如何避免行内style -->
        <!-- 优化点 -->
        <div style="display: flex; justify-content: center; margin-right: 10px">
          <img :src="logo" alt="logo" />
        </div>
        <!-- <h3 class="md-title">全国大学生测试大赛</h3> -->
      </div>
      <div class="md-toolbar-section-end">
        <md-button
          class="md-just-icon md-simple md-toolbar-toggle"
          :class="{ toggled: toggledClass }"
          @click="toggleNavbarMobile()"
        >
          <!-- 这是横线： ——    -->
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </md-button>

        <div class="md-collapse">
          <div class="md-collapse-wrapper">
            <mobile-menu nav-mobile-section-start="false">
              <!-- Here you can add your items from the section-start of your toolbar -->
            </mobile-menu>
            <md-list>
              <md-list-item
                href="javascript:void(0)"
                @click="jumpto(9)"
                v-if="hasLogIn"
              >
                <i class="el-icon-s-flag"></i>
                <p>{{ $t("narBar.competition") }}</p>
              </md-list-item>
              <md-list-item
                href="javascript:void(0)"
                @click="jumpto(3)"
                v-if="hasLogIn"
              >
                <i class="el-icon-s-flag"></i>
                <p>{{ $t("narBar.task") }}</p>
              </md-list-item>
              <md-list-item
                href="javascript:void(0)"
                @click="jumpto(4)"
                v-if="hasLogIn"
              >
                <i class="el-icon-s-flag"></i>
                <p>{{ $t("narBar.class") }}</p>
              </md-list-item>
              <md-list-item v-if="!hasLogIn">
                <md-button class="md-warning">{{
                  $t("narBar.loginAndRegister")
                }}</md-button>
              </md-list-item>
              <li class="md-list-item" v-if="hasLogIn">
                <a
                  href="javascript:void(0)"
                  class="md-list-item-router md-list-item-container md-button-clean dropdown"
                >
                  <div class="md-list-item-content">
                    <drop-down direction="down" class="profile-photo">
                      <div
                        class="profile-photo-small"
                        slot="title"
                        data-toggle="dropdown"
                      >
                        <img :src="img" alt="Circle Image" />
                      </div>
                      <ul class="dropdown-menu dropdown-menu-right">
                        <li class="dropdown-header">
                          {{ $t("narBar.account") }}
                        </li>
                        <li>
                          <a href="#/profile" class="dropdown-item">{{
                            $t("narBar.profile")
                          }}</a>
                        </li>
                        <li>
                          <a @click="logOut" class="dropdown-item">{{
                            $t("narBar.logout")
                          }}</a>
                        </li>
                      </ul>
                    </drop-down>
                  </div>
                </a>
              </li>
              <md-list-item href="javascript:void(0)" @click="changeLang()">
                <p>中/Eng</p>
              </md-list-item>
            </md-list>
          </div>
        </div>
      </div>
    </div>
  </md-toolbar>
</template>

<script>
let resizeTimeout;
function resizeThrottler(actualResizeHandler) {
  // ignore resize events as long as an actualResizeHandler execution is in the queue
  if (!resizeTimeout) {
    resizeTimeout = setTimeout(() => {
      resizeTimeout = null;
      actualResizeHandler();

      // The actualResizeHandler will execute at a rate of 15fps
    }, 66);
  }
}

import MobileMenu from "@/layout/MobileMenu";
export default {
  components: {
    MobileMenu,
  },
  props: {
    type: {
      type: String,
      default: "white",
      validator(value) {
        return [
          "white",
          "default",
          "primary",
          "danger",
          "success",
          "warning",
          "info",
        ].includes(value);
      },
    },
    colorOnScroll: {
      type: Number,
      default: 0,
    },
    logo: {
      type: String,
      default: require("@/assets/img/mooctest/mooctest.png"),
    },
    img: {
      type: String,
      default: require("@/assets/img/mooctest/logo.png"),
    },
  },
  data() {
    return {
      extraNavClasses: "",
      toggledClass: false,
    };
  },
  computed: {
    hasLogIn() {
      const excludedRoutes = ["login", "landing"];
      return excludedRoutes.every((r) => r !== this.$route.name);
    },
  },
  methods: {
    logOut() {
      localStorage.clear();
      sessionStorage.clear();
      this.$router.push({ name: "loginPage" });
    },
    bodyClick() {
      let bodyClick = document.getElementById("bodyClick");

      if (bodyClick === null) {
        let body = document.querySelector("body");
        let elem = document.createElement("div");
        elem.setAttribute("id", "bodyClick");
        body.appendChild(elem);

        let bodyClick = document.getElementById("bodyClick");
        bodyClick.addEventListener("click", this.toggleNavbarMobile);
      } else {
        bodyClick.remove();
      }
    },
    toggleNavbarMobile() {
      this.NavbarStore.showNavbar = !this.NavbarStore.showNavbar;
      this.toggledClass = !this.toggledClass;
      this.bodyClick();
    },
    handleScroll() {
      let scrollValue =
        document.body.scrollTop || document.documentElement.scrollTop;
      let navbarColor = document.getElementById("toolbar");
      this.currentScrollValue = scrollValue;
      // if (this.colorOnScroll > 0 && scrollValue > this.colorOnScroll) {
      //   this.extraNavClasses = `md-${this.type}`;
      //   navbarColor.classList.remove("md-transparent");
      // } else if (this.extraNavClasses) {
      //     if (this.colorOnScroll==0) {
      //       return;
      //     }
      //     this.extraNavClasses = "";
      //     navbarColor.classList.add("md-transparent");
      //   }
    },
    scrollListener() {
      resizeThrottler(this.handleScroll);
    },
    scrollToElement() {
      let element_id = document.getElementById("downloadSection");
      if (element_id) {
        element_id.scrollIntoView({ block: "end", behavior: "smooth" });
      }
    },
    jumpto(page) {
      //考虑后续扩展，如果新增页面，是否需要改代码？
      //switch是不科学的
      //优化点
      switch (page) {
        case 0:
          this.$router.push("/home");
          break;
        case 1:
          this.$router.push("/lesson");
          break;
        case 2:
          this.$router.push("/notice");
          break;
        case 3:
          this.$router.push("/task");
          break;
        case 4:
          this.$router.push("/class");
          break;
        case 5:
          this.$router.push("/paper");
          break;
        case 8:
          this.$router.push("/case");
          break;
        case 9:
          this.$router.push("/competition/list");
          break;
        default:
          this.$router.push("/home");
          break;
      }
    },
    changeLang() {
      if (this.$i18n.locale === "cn") {
        this.$i18n.locale = "en";
        localStorage.setItem("lang", "en");
      } else {
        this.$i18n.locale = "cn";
        localStorage.setItem("lang", "cn");
      }
    },
  },
  mounted() {
    document.addEventListener("scroll", this.scrollListener);
  },
  beforeDestroy() {
    document.removeEventListener("scroll", this.scrollListener);
  },
  //changeLang
};
</script>

<style scoped>
.logo {
  height: 40px;
  width: 40px;
  display: flex;
  justify-content: center;
  margin-right: 10px;
}
.bgimg {
  height: 40px;
  background-image: url("../assets/img/mooctest/headerBackground.png");
}
.md-toolbar {
  /* background-color: red; */
  background-image: url("../assets/img/mooctest/headerBackground.png");
}
</style>
